module.exports = __webpack_public_path__ + "static/media/github.4ffd4fe7.svg";